export const checkBackgroundColor = color => {
  let regex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
  if (color === null) {
    return "#ffffff"
  }
  if (regex.test(color) === true) {
    return color
  } else {
    return "#ffffff"
  }
}
